var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.099,
    height: 12,
    viewBox: "0 0 25.099 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-66.401 -638)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(133.401 1182) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    transform: "translate(55 532)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41,1.41,6,0,0,6l6,6,1.41-1.41L2.83,6Z",
    transform: "translate(64.41 544) rotate(180)",
    fill: "#d9d9d8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21,1H0V-1H21Z",
    transform: "translate(70.5 644.1)",
    fill: "#d9d9d8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHand);
export default __webpack_public_path__ + "static/media/arrow_hand.fb02747bc5324c20d656a0fb8a69a36d.svg";
export { ForwardRef as ReactComponent };